export const accounts = [
  {
    id: 1,
    icon: "bitcoin",
    text: "warning",
    wallet: "Bitcoin",
    coine: "1.02356 BTC",
    price: "9148",
  },
  {
    id: 2,
    icon: "ethereum",
    text: "primary",
    wallet: "Ethereum",
    coine: "0.04121 ETH",
    price: "4721",
  },
  {
    id: 3,
    icon: "litecoin",
    text: "info",
    wallet: "litecoin",
    coine: "0.00356 BTC",
    price: "4721",
  },
];

export const account_types = [
  { label: "Asset", value: "asset" },
  { label: "Liability", value: "liability" },
  { label: "Equity", value: "equity" },
  { label: "Revenue", value: "revenue" },
  { label: "Expense", value: "expense" },
];
